import React, { useRef, useState } from "react";

import defaultBackgroundImgSrc from "../../assets/planeCanvas.webp";
import defaultImgSrc from "../../assets/default.webp";

import ToolButtons from "./ToolButtons/ToolButtons";
import TextFieldsContainer from "./TextFieldsContainer";
import CanvasSliderContainer from "./CanvasSliderContainer";
import ImageCanvas from "./imageCanvas/ImageCanvas";
import FontSelector from "./FontSelector";
import { Grid, Container, List } from "@mui/material";
import LanguageSelector from "./LanguageSelector/LanguageSelector";

const CanvasEditor: React.FC = () => {
  const stageRef = useRef(null);

  const [weekEndTaskY, setWeekEndTaskY] = useState<number>(5);

  const titleXDefault = 10;
  const titleYDefault = 10;
  const titleFontSizeDefault = 45;
  const dowYDefault = 60;
  const weekEndYDefault = 30;
  const [TitleX, setTitleX] = useState<number>(titleXDefault);
  const [TitleY, setTitleY] = useState<number>(titleYDefault);
  const [titleText, setTitleText] = useState<string>("sample title");
  const [titleFontSize, setTitleFontSize] =
    useState<number>(titleFontSizeDefault);
  const [weekEndY, setWeekEndY] = useState<number | number[]>(weekEndYDefault);
  const [DowY, setDowY] = useState<number>(dowYDefault);

  const weekFontSize = 12.8;

  const [fontFamilyName, setFontFamilyName] = useState("メイリオ");

  const [BGHue, setBGHue] = useState<number>(0); //背景色HSV
  const [BGVal, setBGVal] = useState<number>(0);

  //dataソースを入れておくとこ
  const [AddingImgSrc, setImgSrc] = useState<string | ArrayBuffer | null>(
    defaultImgSrc
  );
  const [BackgourndSrc, setBackgourndSrc] = useState<
    string | ArrayBuffer | null
  >(defaultBackgroundImgSrc);

  //タスク格納
  const [DowTasks, setDowTasks] = useState(["", "", "", "", "", "", ""]);

  return (
    <div className="CanvasEditor">
      <Grid container justifyContent="space-around">
        <Grid item>
          <LanguageSelector />
          <List
            sx={{
              maxHeight: 500,
              overflow: "auto",
            }}
          >
            <Container maxWidth="sm">
              <TextFieldsContainer
                setDowTasks={setDowTasks}
                DowTasks={DowTasks}
                setTitleText={setTitleText}
              />
              <FontSelector
                familyName={fontFamilyName}
                setFontFamilyName={setFontFamilyName}
              />
            </Container>
            <CanvasSliderContainer
              setTitleX={setTitleX}
              setTitleY={setTitleY}
              setDowY={setDowY}
              setBGHue={setBGHue}
              setBGVal={setBGVal}
              setWeekEndY={setWeekEndY}
              titleXDefault={titleXDefault}
              titleYDefault={titleYDefault}
              dowYDefault={dowYDefault}
              weekEndYDefault={weekEndYDefault}
              setTitleFontSize={setTitleFontSize}
              titleFontSizeDefault={titleFontSizeDefault}
            />
          </List>
          <ToolButtons
            stageRef={stageRef}
            setImgSrc={setImgSrc}
            setBackgourndSrc={setBackgourndSrc}
          />
        </Grid>

        <Grid className="imageGrid" item>
          <ImageCanvas
            stageRef={stageRef}
            BGHue={BGHue}
            BGVal={BGVal}
            BackgourndSrc={BackgourndSrc}
            DowTasks={DowTasks}
            DowY={DowY}
            weekFontSize={weekFontSize}
            weekEndTaskY={weekEndTaskY}
            AddingImgSrc={AddingImgSrc}
            fontFamilyName={fontFamilyName}
            weekEndY={weekEndY}
            TitleX={TitleX}
            TitleY={TitleY}
            titleFontSize={titleFontSize}
            titleText={titleText}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CanvasEditor;
